// import Liquid from '../../components/pagesbuilder/liquid/Liquid'
import Html from './Html'
import Embed from './Embed'
import Media from './Media'
import Iframe from './Iframe'
import CoursesWrapper from './CoursesWrapper.vue'

export const LIQUID = 'liquid'
export const HTML = 'html'
export const MEDIA = 'media'
export const EMBED = 'embed'
export const IFRAME = 'iframe'
export const COURSESWRAPPER = 'courseswrapper'
export const DEFAULT = HTML

const mapping = {
    // [LIQUID]: Liquid,
    [HTML]: Html,
    [EMBED]: Embed,
    [IFRAME]: Iframe,
    [MEDIA]: Media,
    [COURSESWRAPPER]: CoursesWrapper,
}

export const getComponent = (id) => {
    return mapping[id]? mapping[id] : undefined
}

export default mapping